import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center" style={{ padding: "60px 20px" }}>
      <div className="container">
        <div className="section-title">
          <h2 style={{ fontSize: "2rem", fontWeight: "700" }}>Gallery</h2>
          <p style={{ maxWidth: "600px", margin: "0 auto", fontSize: "1rem" }}>
            .
          </p>
        </div>

        <div
          className="gallery-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
            marginTop: "30px",
          }}
        >
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="gallery-item"
                  style={{
                    borderRadius: "12px",
                    overflow: "hidden",
                    background: "#fff",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    transition: "transform 0.3s ease",
                    pointerEvents: "none", // <-- disable clicks here
                  }}
                >
                  <Image
                    title={d.title}
                    largeImage={d.largeImage}
                    smallImage={d.smallImage}
                  />
                  <p
                    style={{
                      margin: "10px 0",
                      fontWeight: "600",
                      fontSize: "1rem",
                      color: "#333",
                    }}
                  >
                    {d.title}
                  </p>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
